export function StatusBadge({ status }) {
  const map = {
    pending: "bg-amber-500/15 text-amber-400 border-amber-500/30",
    processing: "bg-cyan-500/15 text-cyan-400 border-cyan-500/30",
    paid: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
    failed: "bg-rose-500/15 text-rose-400 border-rose-500/30",
    confirmed: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
    cancelled: "bg-rose-500/15 text-rose-400 border-rose-500/30",
    active: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
    rejected: "bg-rose-500/15 text-rose-400 border-rose-500/30",
    inactive: "bg-zinc-500/15 text-zinc-400 border-zinc-500/30",
  };
  const label = {
    pending: "Pending", processing: "Processing", paid: "Paid", failed: "Failed",
    confirmed: "Confirmed", cancelled: "Cancelled", active: "Active", rejected: "Ditolak", inactive: "Nonaktif",
  };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${map[status] || "bg-secondary text-muted-foreground border-border"}`}
    >
      {label[status] || status}
    </span>
  );
}
